export class Product {
    id:number = 0;
    name:string = '';
    active:boolean = true;
    division:string = 'Minerales';
}
